import amerenAverageKwhEnDesktop from 'static/ameren-average-kwh-english-desktop.png';
import amerenAverageKwhEnMobile from 'static/ameren-average-kwh-english-mobile.png';
import amerenDailyUsage from 'static/ameren-daily-use.png';
import amerenYearlyKwhEnDesktop from 'static/ameren-il-yearly-kwh-desktop.jpg';
import amerenMeterUsageEnDesktop from 'static/ameren-meter-usage-english-desktop.png';
import amerenMeterUsageEnMobile from 'static/ameren-meter-usage-english-mobile.png';
import arcadiaLogo from 'static/arcadia.svg';
import businessContractImage from 'static/business-contracts.webp';
import celestialSolarImage from 'static/celestial-solar-farm.webp';
import commonwealthEdisonDailyUsage from 'static/comed-daily-use.png';
import createAccountImageEn from 'static/create-account-english.webp';
import createAccountImageEs from 'static/create-account-spanish.webp';
import epharataSolarImage from 'static/epharata.webp';
import eversourceMeterNumberEnDesktop from 'static/eversource-meter-usage-english-desktop.png';
import eversourceMeterNumberEnMobile from 'static/eversource-meter-usage-english-mobile.png';
import explainer from 'static/explainer.svg';
import familyPhoneImage from 'static/family-dancing-phone-display.webp';
import getStarted from 'static/get-started-3x.gif';
import getStartedCarousel from 'static/get-started-carousel.svg';
import giffordSolarImage from 'static/gifford-solar-farm.webp';
import globeHomeImage from 'static/globe-home.webp';
import greenHomeImage from 'static/green-home.svg';
import halfmoonSolarImage from 'static/halfmoon-solar-farm.webp';
import howItWorks from 'static/how-it-works-3x.gif';
import howItWorksCarousel from 'static/how-it-works-carousel.svg';

import oregonDisclaimerImage from 'static/oregon-disclaimer.svg';
import orleansSolarImage from 'static/orleans-solar-farm.webp';
import paymentImage from 'static/payment.webp';
import pdfFileImage from 'static/pdf-file.svg';
import quoteCardImage from 'static/quote-card.svg';
import readyToSubscribe from 'static/ready-to-subscribe-3x.gif';
import readyToSubscribeCarousel from 'static/ready-to-subscribe-carousel.svg';
import selectUtilityImage from 'static/select-utility.webp';
import solarPhoneImage from 'static/solar-farm-phone-display.webp';
import solarWithoutARoof from 'static/solar-without-a-roof-3x.gif';
import solarWithoutARoofCarousel from 'static/solar-without-a-roof-carousel.svg';
import termsImage from 'static/terms.webp';
import unitilYearlyKwhEnDesktop from 'static/unitil-ma-annual-kwh-desktop.jpg';
import unitilNameKeyForEdi from 'static/unitil-name-key-for-edi.png';
import utilityConnectImage from 'static/utility-connect.webp';
import windfarmImage from 'static/windfarm.webp';
import xcelDailyUsage from 'static/xcel-daily-usage.png';
import zuoraLogo from 'static/zuora-logo.svg';
import { IS_PERCH_ENERGY, ORGANIZATION_ENTITIES } from '~/utils/constants';
import { determineLanguage } from '~/utils/funnels';
import { Image } from '../image.component';

export type ImageInfo = Record<
  string,
  {
    altText: string;
    caption: string;
    source:
      | string
      | {
          desktop: string;
          mobile: string;
        };
  }
>;
const entityName = IS_PERCH_ENERGY ? ORGANIZATION_ENTITIES.PERCH : ORGANIZATION_ENTITIES.ARCADIA;
export const imageInfo: ImageInfo = {
  AMEREN_AVERAGE_KWH: {
    altText: 'An example of an Ameren bill that highlights the average daily kWh.',
    caption: '',
    source: {
      desktop: amerenAverageKwhEnDesktop,
      mobile: amerenAverageKwhEnMobile,
    },
  },
  AMEREN_AVERAGE_YEARLY_KWH: {
    altText: 'An example of an Ameren bill that highlights the average yearly kWh.',
    caption: '',
    source: {
      desktop: amerenYearlyKwhEnDesktop,
      mobile: amerenYearlyKwhEnDesktop,
    },
  },
  UNITIL_AVERAGE_YEARLY_KWH: {
    altText: 'An example of an Unitil bill that highlights the average yearly kWh.',
    caption: '',
    source: {
      desktop: unitilYearlyKwhEnDesktop,
      mobile: unitilYearlyKwhEnDesktop,
    },
  },
  UNITIL_NAME_KEY: {
    altText: 'An example of an Unitil bill that highlights the name key.',
    caption: '',
    source: {
      desktop: unitilNameKeyForEdi,
      mobile: unitilNameKeyForEdi,
    },
  },
  AMEREN_METER_USAGE: {
    altText: 'An example of an Ameren bill that highlights the meter number.',
    caption: '',
    source: { desktop: amerenMeterUsageEnDesktop, mobile: amerenMeterUsageEnMobile },
  },
  EVERSOURCE_METER_USAGE: {
    altText: 'An example of an Eversource bill that highlights the meter number.',
    caption: '',
    source: { desktop: eversourceMeterNumberEnDesktop, mobile: eversourceMeterNumberEnMobile },
  },
  PAYMENT_IMAGE: {
    altText: 'Solar payment',
    caption:
      'You’ll receive a streamlined monthly statement showing your utility charges and your solar savings in one place.',
    source: paymentImage,
  },
  CELESTIAL_SOLAR: {
    altText: 'Celestial solar',
    caption: 'Celestial solar farm, powering 10 homes.',
    source: celestialSolarImage,
  },
  EPHARATA_SOLAR: {
    altText: 'Epharata solar',
    caption:
      'Community solar makes it easy to get the cost-saving benefits of solar without installing your own panels.',
    source: epharataSolarImage,
  },
  FAMILY_PHONE: {
    altText: 'Family dancing',
    caption: '',
    source: familyPhoneImage,
  },
  GIFFORD_SOLAR: {
    altText: 'Gifford solar',
    caption: 'Gifford solar farm, powering 345 homes.',
    source: giffordSolarImage,
  },
  GLOBE_HOME: {
    altText: 'Globe Home',
    caption:
      'Community solar makes it easy to get the cost-saving benefits of solar without installing your own panels.',
    source: globeHomeImage,
  },
  GREEN_HOME: {
    altText: 'Green Home',
    caption: `Once your community solar farm turns on, you’ll be able to see your clean energy impact anytime in your ${entityName} dashboard.`,
    source: greenHomeImage,
  },
  HALFMOON_SOLAR: {
    altText: 'Halfmoon solar',
    caption: 'Halfmoon solar farm, powering 354 homes.',
    source: halfmoonSolarImage,
  },
  UTILITY_CONNECT_IMAGE: {
    altText: 'Globe home',
    caption:
      'We work with your utility to track your solar savings and add them to your monthly power bill.',
    source: utilityConnectImage,
  },
  ORLEANS_SOLAR: {
    altText: 'Orleans solar',
    caption: 'Orleans solar farm, powering 18 homes.',
    source: orleansSolarImage,
  },
  QUOTE_CARD: {
    altText: 'Customer satisfaction quote',
    caption: '',
    source: quoteCardImage,
  },
  SELECT_UTILITY_IMAGE: {
    altText: 'Solar globe',
    caption: '',
    source: selectUtilityImage,
  },
  CREATE_ACCOUNT_IMAGE: {
    altText: 'Your solar panel and your neighbor’s solar panel in a solar farm',
    caption:
      'Community solar makes it easy to get the cost-saving benefits of solar without installing your own panels.',
    source: determineLanguage() === 'es' ? createAccountImageEs : createAccountImageEn,
  },
  SOLAR_PHONE: {
    altText: 'Solar farm',
    caption: '',
    source: solarPhoneImage,
  },
  TERMS_IMAGE: {
    altText: 'Solar usage phone',
    caption: `Once your community solar farm turns on, you’ll be able to see your clean energy impact anytime in your ${entityName} dashboard.`,
    source: termsImage,
  },
  TERMS_IMAGE_WAITLIST: {
    altText: 'Solar usage phone',
    caption:
      'Once community solar is available to you, we’ll contact you to officially enroll you in a solar farm. Then you’ll be helping create more clean energy!',
    source: termsImage,
  },
  WIND_FARM: {
    altText: 'Rattlesnake wind farm',
    caption: `${entityName} allows you to power your home with clean and renewable energy, without changing your electricity service.`,
    source: windfarmImage,
  },
  GET_STARTED: {
    altText: 'Micro learning signup',
    source: getStarted,
    caption: '',
  },
  SOLAR_WITHOUT_A_ROOF: {
    altText: 'Micro learning signup',
    source: solarWithoutARoof,
    caption: '',
  },
  HOW_IT_WORKS: {
    altText: 'Micro learning signup',
    source: howItWorks,
    caption: '',
  },
  READY_TO_SUBSCRIBE: {
    altText: 'Micro learning signup',
    source: readyToSubscribe,
    caption: '',
  },
  GET_STARTED_CAROUSEL: {
    altText: 'Index 1',
    source: getStartedCarousel,
    caption: '',
  },
  SOLAR_WITHOUT_ROOF_CAROUSEL: {
    altText: 'Index 2',
    source: solarWithoutARoofCarousel,
    caption: '',
  },
  HOW_IT_WORKS_CAROUSEL: {
    altText: 'Index 3',
    source: howItWorksCarousel,
    caption: '',
  },
  READY_TO_SUBSCRIBE_CAROUSEL: {
    altText: 'Index 4',
    source: readyToSubscribeCarousel,
    caption: '',
  },
  EXPLAINER: {
    altText: 'Explainer',
    source: explainer,
    caption: '',
  },
  OREGON_DISCLAIMER: {
    altText: 'Oregon disclaimer',
    source: oregonDisclaimerImage,
    caption: '',
  },
  PDF_FILE: {
    altText: 'PDF file',
    source: pdfFileImage,
    caption: '',
  },
  BUSINESS_CONTRACT: {
    altText: 'Your solar panel and your neighbor’s and nearby business solar panel in a solar farm',
    source: businessContractImage,
    caption: '',
  },
  XCEL_DAILY_KWH: {
    altText: 'An example of an Xcel Energy bill that highlights the daily kWh usage.',
    caption: '',
    source: xcelDailyUsage,
  },
  COMMONWEALTH_EDISON_DAILY_KWH: {
    altText: 'An example of a Commonwealth Edison bill that highlights the daily kWh usage.',
    caption: '',
    source: commonwealthEdisonDailyUsage,
  },
  AMEREN_DAILY_KWH: {
    altText: 'An example of an Ameren bill that highlights the daily kWh usage.',
    caption: '',
    source: amerenDailyUsage,
  },
  ZUORA_LOGO: {
    altText: 'Zuora logo',
    caption: '',
    source: zuoraLogo,
  },
  ARCADIA_LOGO: {
    altText: 'Arcadia logo',
    caption: '',
    source: arcadiaLogo,
  },
} as const;

export type ImageType = keyof typeof imageInfo;

export const AMEREN_AVERAGE_KWH = 'AMEREN_AVERAGE_KWH';
export const AMEREN_METER_USAGE = 'AMEREN_METER_USAGE';
export const EVERSOURCE_METER_USAGE = 'EVERSOURCE_METER_USAGE';
export const AMEREN_AVERAGE_YEARLY_KWH = 'AMEREN_AVERAGE_YEARLY_KWH';
export const UNITIL_AVERAGE_YEARLY_KWH = 'UNITIL_AVERAGE_YEARLY_KWH';
export const PAYMENT_IMAGE = 'PAYMENT_IMAGE';
export const CELESTIAL_SOLAR = 'CELESTIAL_SOLAR';
export const CREATE_ACCOUNT_IMAGE = 'CREATE_ACCOUNT_IMAGE';
export const EPHARATA_SOLAR = 'EPHARATA_SOLAR';
export const FAMILY_PHONE = 'FAMILY_PHONE';
export const GIFFORD_SOLAR = 'GIFFORD_SOLAR';
export const GLOBE_HOME = 'GLOBE_HOME';
export const GREEN_HOME = 'GREEN_HOME';
export const TERMS_IMAGE_WAITLIST = 'TERMS_IMAGE_WAITLIST';
export const HALFMOON_SOLAR = 'HALFMOON_SOLAR';
export const SELECT_UTILITY_IMAGE = 'SELECT_UTILITY_IMAGE';
export const ORLEANS_SOLAR = 'ORLEANS_SOLAR';
export const QUOTE_CARD = 'QUOTE_CARD';
export const SOLAR_PHONE = 'SOLAR_PHONE';
export const UTILITY_CONNECT_IMAGE = 'UTILITY_CONNECT_IMAGE';
export const TERMS_IMAGE = 'TERMS_IMAGE';
export const WIND_FARM = 'WIND_FARM';
export const GET_STARTED = 'GET_STARTED';
export const SOLAR_WITHOUT_A_ROOF = 'SOLAR_WITHOUT_A_ROOF';
export const HOW_IT_WORKS = 'HOW_IT_WORKS';
export const READY_TO_SUBSCRIBE = 'READY_TO_SUBSCRIBE';
export const GET_STARTED_CAROUSEL = 'GET_STARTED_CAROUSEL';
export const SOLAR_WITHOUT_ROOF_CAROUSEL = 'SOLAR_WITHOUT_ROOF_CAROUSEL';
export const HOW_IT_WORKS_CAROUSEL = 'HOW_IT_WORKS_CAROUSEL';
export const READY_TO_SUBSCRIBE_CAROUSEL = 'READY_TO_SUBSCRIBE_CAROUSEL';
export const EXPLAINER = 'EXPLAINER';
export const OREGON_DISCLAIMER = 'OREGON_DISCLAIMER';
export const PDF_FILE = 'PDF_FILE';
export const UNITIL_NAME_KEY = 'UNITIL_NAME_KEY';
export const BUSINESS_CONTRACT = 'BUSINESS_CONTRACT';
export const XCEL_DAILY_KWH = 'XCEL_DAILY_KWH';
export const AMEREN_DAILY_KWH = 'AMEREN_DAILY_KWH';
export const COMMONWEALTH_EDISON_DAILY_KWH = 'COMMONWEALTH_EDISON_DAILY_KWH';
export const ZUORA_LOGO = 'ZUORA_LOGO';
export const ARCADIA_LOGO = 'ARCADIA_LOGO';

type ImageSelectorProps = {
  type: ImageType;
  overrideCaption?: string;
  maxWidth?: string;
};

export const ImageSelector = ({ type, overrideCaption, maxWidth }: ImageSelectorProps) => {
  const { altText, caption, source } = imageInfo[type];

  return (
    <Image
      altText={altText}
      caption={overrideCaption === undefined ? caption : overrideCaption}
      source={source}
      maxWidth={maxWidth}
    />
  );
};
